import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteClientMutationVariables = Types.Exact<{
  data: Types.DeleteClientInput;
}>;


export type DeleteClientMutation = { deleteClient?: { success?: boolean | null } | null };


export const DeleteClientDocument = /*#__PURE__*/ gql`
    mutation DeleteClient($data: DeleteClientInput!) {
  deleteClient(data: $data) {
    success
  }
}
    `;

export function useDeleteClientMutation() {
  return Urql.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument);
};